export const Video = ({
    src,
    className,
    alt = "",
    objectFit = "contain",
    width = "100%",
    height = "100%",
    previewOnly = false,
    onPlay,
    onClick,
    onLoadedMetadata,
    ...props
}) => {

    return (
        <div style={{ width, height }} className={className}>
            <video
                src={src}
                alt={alt}
                style={{ width: "100%", height: "100%", objectFit }}
                {...props}
                playsInline
                preload={previewOnly ? "auto" : props.preload}
                controls={!previewOnly}
                muted={previewOnly ? true : props.muted}
                disablePictureInPicture={previewOnly ? true : props.disablePictureInPicture}
                controlsList={previewOnly ? "nodownload noplaybackrate noremoteplayback" : props.controlsList}
                tabIndex={previewOnly ? -1 : props.tabIndex}
                onLoadedMetadata={(e) => {
                    if (previewOnly) {
                        try {
                            e.currentTarget.currentTime = 0;
                        } catch (err) {
                            // ignore
                        }
                    }
                    onLoadedMetadata?.(e);
                }}
                onPlay={(e) => {
                    if (previewOnly) {
                        e.preventDefault();
                        try {
                            e.currentTarget.pause();
                            e.currentTarget.currentTime = 0;
                        } catch (err) {
                            // ignore
                        }
                    }
                    onPlay?.(e);
                }}
                onClick={(e) => {
                    if (previewOnly) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    onClick?.(e);
                }}
            />
        </div>
    );
}